export const MAX_KEYWORDS_LENGTH = 500;
